import classnames from 'classnames';
import React, { useContext, useState } from 'react';

import { MarketContext } from '../../context/markets';
import { __ } from '../../helpers/TranslationService';
import { IHeader } from '../../interfaces/IHeader';
import { IBrandConfig } from '../../reducers/pageData';
import { HeaderMainNavigation } from './HeaderMainNavigation';

export function BurgerButton({ onClick }: { onClick?: React.EventHandler<any> }) {
    return (
        <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#globalPage_navigation"
            onClick={onClick}
        >
            <span className="sr-only">{__('Toggle navigation', 'dreamlines')}</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
        </button>
    );
}
interface IHeaderMainNavBar {
    items: IHeader;
    countryCode: string;
    apiHost: string;
    brandConfig: IBrandConfig;
}

export const HeaderMainNavBar = (props: IHeaderMainNavBar) => {
    const { items } = props;
    const { markets } = useContext(MarketContext);
    const { isCruise1st } = markets;

    const [isMobileMenuCollapsed, setIsMobileMenuCollapsed] = useState(true);
    const classes = classnames('navbar', { 'navbar-white': isCruise1st });
    return (
        <>
            <nav className={classes}>
                <div className="container">
                    <div className="row">
                        {/** Brand and toggle get grouped for better mobile display */}
                        <div className="navbar-header">
                            <BurgerButton
                                onClick={(evt) => setIsMobileMenuCollapsed(!isMobileMenuCollapsed)}
                            />
                        </div>
                        <HeaderMainNavigation
                            items={items}
                            isCollapsed={isMobileMenuCollapsed}
                            countryCode={props.countryCode}
                            apiHost={props.apiHost}
                            brandConfig={props.brandConfig}
                        />
                    </div>
                </div>
            </nav>
        </>
    );
};
